import React from "react";
import { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import CONFIG_OBJECT from "../../../config/config";
import { postDataFetcher } from "../../../dataFetcher";
import configData from "../../../temp/config";
import OutsideAlerter from "../outside-alerter/outsideAlerter";

const SetReminders = (props) => {
  const [isClickedOutSide, setIsClickedOutSide] = useState(false);
  const [showSetRemindersPopup, setShowSetRemindersPopup] = useState(false);

  const [periodDaysTabSelected, setPeriodDaysTabSelected] = useState(false);
  const [fertileDaysTabSelected, setFertileDaysTabSelected] = useState(false);
  const [ovulationDaysTabSelected, setOvulationDaysTabSelected] = useState(
    false
  );

  useEffect(() => {
    if (isClickedOutSide && showSetRemindersPopup) {
      setIsClickedOutSide(false);
      setShowSetRemindersPopup(false);
    }

    if (
      props.showPeriodDays &&
      !props.showFertileDays &&
      !props.showOvulationDays
    ) {
      setPeriodDaysReminder(true);
      setFertileDaysReminder(false);
      setOvulationDaysReminder(false);
      setPeriodDaysTabSelected(true);
    } else {
      setPeriodDaysTabSelected(false);
    }
    if (
      !props.showPeriodDays &&
      props.showFertileDays &&
      !props.showOvulationDays
    ) {
      setPeriodDaysReminder(false);
      setFertileDaysReminder(true);
      setOvulationDaysReminder(false);
      setFertileDaysTabSelected(true);
    } else {
      setFertileDaysTabSelected(false);
    }
    if (
      !props.showPeriodDays &&
      !props.showFertileDays &&
      props.showOvulationDays
    ) {
      setPeriodDaysReminder(false);
      setFertileDaysReminder(false);
      setOvulationDaysReminder(true);
      setOvulationDaysTabSelected(true);
    } else {
      setOvulationDaysTabSelected(false);
    }

    if (
      props.showPeriodDays &&
      props.showFertileDays &&
      !props.showOvulationDays
    ) {
      setPeriodDaysReminder(true);
      setFertileDaysReminder(false);
      setOvulationDaysReminder(false);
    } else if (
      props.showPeriodDays &&
      !props.showFertileDays &&
      props.showOvulationDays
    ) {
      setPeriodDaysReminder(true);
      setFertileDaysReminder(false);
      setOvulationDaysReminder(false);
    } else if (
      !props.showPeriodDays &&
      props.showFertileDays &&
      props.showOvulationDays
    ) {
      setPeriodDaysReminder(false);
      setFertileDaysReminder(true);
      setOvulationDaysReminder(false);
    }
  }, [props.showFertileDays, props.showOvulationDays, props.showPeriodDays]);

  const ClosePopup = (event) => {
    event.preventDefault();
    if (showSetRemindersPopup) {
      setShowSetRemindersPopup(false);
    }
  };

  const SetRemindersClick = (event) => {
    event.preventDefault();
    setShowSetRemindersPopup((prev) => !prev);
    setIsClickedOutSide(false);
  };

  const [fertileDaysReminder, setFertileDaysReminder] = useState(false);
  const HandleSetRemindersFertileDays = () => {
    setFertileDaysReminder((prev) => !prev);
    setOvulationDaysReminder(false);
    setPeriodDaysReminder(false);
  };

  const [periodDaysReminder, setPeriodDaysReminder] = useState(true);
  const HandleSetRemindersPeriodDays = () => {
    setPeriodDaysReminder((prev) => !prev);
    setOvulationDaysReminder(false);
    setFertileDaysReminder(false);
  };

  const [ovulationDaysReminder, setOvulationDaysReminder] = useState(false);
  const HandleSetRemindersOvulationDays = () => {
    setOvulationDaysReminder((prev) => !prev);
    setPeriodDaysReminder(false);
    setFertileDaysReminder(false);
  };

  const [periodDaysReminderInputs, setPeriodDaysReminderInputs] = useState({
    itemID: "",
    reminderKey: "",
    defaultTime: "",
    numberOfRecurrences: "",
  });

  const [fertileDaysReminderInputs, setFertileDaysReminderInputs] = useState({
    itemID: "",
    reminderKey: "",
    defaultTime: "",
    numberOfRecurrences: "",
  });

  const [
    ovulationDaysReminderInputs,
    setOvulationDaysReminderInputs,
  ] = useState({
    itemID: "",
    reminderKey: "",
    defaultTime: "",
    numberOfRecurrences: "",
  });

  useEffect(() => {
    if (props.reminderItems != null) {
      props.reminderItems.forEach((reminder) => {
        if (reminder.fields.key.value === "PERIOD") {
          setPeriodDaysReminderInputs({
            itemID: reminder.id,
            reminderKey: reminder.fields.key.value,
            defaultTime: reminder.fields.DefaultTime.value,
            numberOfRecurrences: reminder.fields.NoofRecurrences.value,
          });
        } else if (reminder.fields.key.value === "FERTILE") {
          setFertileDaysReminderInputs({
            itemID: reminder.id,
            reminderKey: reminder.fields.key.value,
            defaultTime: reminder.fields.DefaultTime.value,
            numberOfRecurrences: reminder.fields.NoofRecurrences.value,
          });
        } else if (reminder.fields.key.value === "OVULATION") {
          setOvulationDaysReminderInputs({
            itemID: reminder.id,
            reminderKey: reminder.fields.key.value,
            defaultTime: reminder.fields.DefaultTime.value,
            numberOfRecurrences: reminder.fields.NoofRecurrences.value,
          });
        }
      });
    }
  }, []);

  const SetRemindersSetClick = (event) => {
    event.preventDefault();

    let url = `${configData.sitecoreApiHost}/${CONFIG_OBJECT.SET_REMINDERS_REST_URL}?sc_apikey=${configData.sitecoreApiKey}`;
    let EventStartDate = `${
      props.lastPeriodFirstday.getMonth() + 1
    }-${props.lastPeriodFirstday.getDate()}-${props.lastPeriodFirstday.getFullYear()}`;
    let cycleLength = props.daysBetweenPeriod;

    let data = {
      CalendarItemId: "",
      EventStartDate: "",
      Interval: cycleLength,
      NoOfRecurrences: "",
      ReminderKey: "",
    };

    if (periodDaysReminder) {
      data = {
        CalendarItemId: periodDaysReminderInputs.itemID,
        EventStartDate:
          EventStartDate + " " + periodDaysReminderInputs.defaultTime,
        NoOfRecurrences: periodDaysReminderInputs.numberOfRecurrences,
        ReminderKey: periodDaysReminderInputs.reminderKey,
        Interval: cycleLength,
      };

      postDataFetcher(url, data).then(
        (res) => {
          if (res.data.HasError) {
          } else {
            if (document != null) {
              if (showSetRemindersPopup) {
                document.PeriodRemindersForm.action = `${url}&CalendarItemId=${data.CalendarItemId}&EventStartDate=${data.EventStartDate}&Interval=${data.Interval}&NoofRecurrences=${data.NoOfRecurrences}&ReminderKey=${data.ReminderKey}`;
                document.PeriodRemindersForm.submit();
                document.PeriodRemindersForm.action = "";
              } else {
                document.RemindersForm.action = `${url}&CalendarItemId=${data.CalendarItemId}&EventStartDate=${data.EventStartDate}&Interval=${data.Interval}&NoofRecurrences=${data.NoOfRecurrences}&ReminderKey=${data.ReminderKey}`;
                document.RemindersForm.submit();
                document.RemindersForm.action = "";
              }
              setShowSetRemindersPopup(false);
            }
          }
        },
        (err) => {}
      );
    }

    if (fertileDaysReminder) {
      data = {
        CalendarItemId: fertileDaysReminderInputs.itemID,
        EventStartDate:
          EventStartDate + " " + fertileDaysReminderInputs.defaultTime,
        NoOfRecurrences: fertileDaysReminderInputs.numberOfRecurrences,
        ReminderKey: fertileDaysReminderInputs.reminderKey,
        Interval: cycleLength,
      };

      postDataFetcher(url, data).then(
        (res) => {
          if (res.data.HasError) {
          } else {
            if (document != null) {
              if (showSetRemindersPopup) {
                document.FertileRemindersForm.action = `${url}&CalendarItemId=${data.CalendarItemId}&EventStartDate=${data.EventStartDate}&Interval=${data.Interval}&NoofRecurrences=${data.NoOfRecurrences}&ReminderKey=${data.ReminderKey}`;
                if (periodDaysReminder) {
                  setTimeout(() => {
                    document.FertileRemindersForm.submit();
                  }, 5000);
                } else {
                  document.FertileRemindersForm.submit();
                }
                document.FertileRemindersForm.action = "";
              } else {
                document.RemindersForm.action = `${url}&CalendarItemId=${data.CalendarItemId}&EventStartDate=${data.EventStartDate}&Interval=${data.Interval}&NoofRecurrences=${data.NoOfRecurrences}&ReminderKey=${data.ReminderKey}`;
                document.RemindersForm.submit();
                document.RemindersForm.action = "";
              }
              setShowSetRemindersPopup(false);
            }
          }
        },
        (err) => {}
      );
    }

    if (ovulationDaysReminder) {
      data = {
        CalendarItemId: ovulationDaysReminderInputs.itemID,
        EventStartDate:
          EventStartDate + " " + ovulationDaysReminderInputs.defaultTime,
        NoOfRecurrences: ovulationDaysReminderInputs.numberOfRecurrences,
        ReminderKey: ovulationDaysReminderInputs.reminderKey,
        Interval: cycleLength,
      };

      postDataFetcher(url, data).then(
        (res) => {
          if (res.data.HasError) {
          } else {
            if (document != null) {
              if (showSetRemindersPopup) {
                document.OvulationRemindersForm.action = `${url}&CalendarItemId=${data.CalendarItemId}&EventStartDate=${data.EventStartDate}&Interval=${data.Interval}&NoofRecurrences=${data.NoOfRecurrences}&ReminderKey=${data.ReminderKey}`;
                document.OvulationRemindersForm.submit();
                document.OvulationRemindersForm.action = "";
              } else {
                document.RemindersForm.action = `${url}&CalendarItemId=${data.CalendarItemId}&EventStartDate=${data.EventStartDate}&Interval=${data.Interval}&NoofRecurrences=${data.NoOfRecurrences}&ReminderKey=${data.ReminderKey}`;
                document.RemindersForm.submit();
                document.RemindersForm.action = "";
              }
              setShowSetRemindersPopup(false);
            }
          }
        },
        (err) => {}
      );
    }
  };

  return (
    <>
      <OutsideAlerter setIsClickedOutSide={setIsClickedOutSide}>
        {showSetRemindersPopup && !isClickedOutSide && (
          <div className="period-reminders-popup">
            <div className="reminders-set-popup">
              <p className="symptoms-heading">
                {props.dictionary("PeriodCalculator_Reminders")}
              </p>
              <div className="symptoms-group">
                <form
                  method="post"
                  name="FertileRemindersForm"
                  id="FertileRemindersForm"
                >
                  <input
                    type="checkbox"
                    className="reminders-checkbox"
                    checked={periodDaysReminder}
                    onChange={HandleSetRemindersPeriodDays}
                  ></input>
                  <span
                    className="reminder-options ml-2"
                    onClick={HandleSetRemindersPeriodDays}
                  >
                    {props.dictionary("PeriodCalculator_PeriodDays")}
                  </span>
                  <br />
                </form>
                <form
                  method="post"
                  name="OvulationRemindersForm"
                  id="OvulationRemindersForm"
                >
                  <input
                    type="checkbox"
                    className="reminders-checkbox"
                    checked={fertileDaysReminder}
                    onChange={HandleSetRemindersFertileDays}
                  ></input>
                  <span
                    className="reminder-options ml-2"
                    onClick={HandleSetRemindersFertileDays}
                  >
                    {props.dictionary("PeriodCalculator_FertileDays")}
                  </span>
                  <br />
                </form>
                <form
                  method="post"
                  name="PeriodRemindersForm"
                  id="PeriodRemindersForm"
                >
                  <input
                    type="checkbox"
                    className="reminders-checkbox"
                    checked={ovulationDaysReminder}
                    onChange={HandleSetRemindersOvulationDays}
                  ></input>
                  <span
                    className="reminder-options ml-2"
                    onClick={HandleSetRemindersOvulationDays}
                  >
                    {props.dictionary("PeriodCalculator_OvulationDays")}
                  </span>
                  <br />
                </form>
                <div className="row set-period-reminders">
                  <div className="col-6 reminders-button-padding">
                    <button
                      className={"reminder-cancel"}
                      onClick={SetRemindersClick}
                    >
                      {props.dictionary("PeriodCalculator_Cancel")}
                    </button>
                  </div>
                  <div className="col-6 reminders-button-padding">
                    <a
                      className={
                        !fertileDaysReminder &&
                        !ovulationDaysReminder &&
                        !periodDaysReminder
                          ? "reminder-tracknow-disabled"
                          : "reminder-tracknow-enabled"
                      }
                      disabled={
                        !fertileDaysReminder &&
                        !ovulationDaysReminder &&
                        !periodDaysReminder
                      }
                      onClick={SetRemindersSetClick}
                    >
                      {props.dictionary("PeriodCalculator_Set")}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {props.validApiData && (
          <form method="post" name="RemindersForm" id="RemindersForm">
            <div
              className="form-mobile set-reminders-button"
              onClick={ClosePopup}
            >
              <a
                className={isMobile?"tracknow-enabled btn-primary":"tracknow-enabled"}
                onClick={
                  periodDaysTabSelected ||
                  fertileDaysTabSelected ||
                  ovulationDaysTabSelected
                    ? SetRemindersSetClick
                    : SetRemindersClick
                }
              >
                {props.dictionary("PeriodCalculator_SetReminders")}
              </a>
            </div>
          </form>
        )}
      </OutsideAlerter>
    </>
  );
};

export default SetReminders;
